import { render, staticRenderFns } from "./ClientPositionReportTemplate.vue?vue&type=template&id=28157aa8&scoped=true"
import script from "./ClientPositionReportTemplate.vue?vue&type=script&lang=js"
export * from "./ClientPositionReportTemplate.vue?vue&type=script&lang=js"
import style0 from "./ClientPositionReportTemplate.vue?vue&type=style&index=0&id=28157aa8&prod&lang=css"
import style1 from "./ClientPositionReportTemplate.vue?vue&type=style&index=1&id=28157aa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28157aa8",
  null
  
)

export default component.exports